import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, title, ...rest }) => {
  const checkLogin = () => {
    const userdetails = JSON.parse(localStorage.getItem("user_details")) || [];
    return (
      localStorage.getItem("userLogin") === "yes" && userdetails.length > 0
    );
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        checkLogin() ? (
          <Component
            {...props}
            {...rest}
            key={
              props?.match?.params?.attribute_set_key || title || "default-key"
            }
            title={title}
          />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
